import Vue from 'vue';

/*
 * Login/Signup related globals
 */
export const authStore = Vue.observable({
	emailSubmitStatus: 'default',
	googleSubmitStatus: 'default',
	facebookSubmitStatus: 'default',
	microsoftSubmitStatus: 'default',
	openIdConnectSubmitStatus: 'default',

	mfa: {
		multifactorToken: null,
		backupEmail: null,
		encryptedAuthMethod: null,
		isSocial: false,
		locked: false
	},

	deviceVerification: {
		token: null
	}
});

export type AuthStore = typeof authStore;
